var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary","loading":_vm.loading,"icon":"el-icon-download","size":"small"},on:{"click":_vm.btnClick}},[_vm._v("导出")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }